import { hostBridge } from '@publicala/delfino';
import type { SearchPayload, SearchResponse } from '@publicala/delfino';
import { DEFAULT_SEARCH_MOCK, isE2EMockActive } from '../../e2eMockGuard';

/**
 * Search API for Volpe.
 * Provides methods to search text content via hostBridge.
 */
class SearchAPI {
    /**
     * Search text content within a publication.
     * Returns mock data in E2E standalone mode.
     *
     * @param payload - Search parameters matching Delfino's SearchPayload
     * @param payload.search - The search term
     * @param payload.issueId - The publication ID
     * @returns Search response with results
     */
    async search(payload: SearchPayload): Promise<SearchResponse> {
        if (isE2EMockActive()) {
            return window.__SEARCH_API_MOCK_RESPONSE__ ?? DEFAULT_SEARCH_MOCK;
        }
        return hostBridge.search.search(payload);
    }
}

export const searchAPI = new SearchAPI();
